exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GalleryBlock-7b2ae44b{position:relative}.GalleryBlock-7b2ae44b:focus{outline:none}.singleImg-0c47a15a{text-align:center}.singleImg-0c47a15a img{max-width:100%;max-height:600px;margin:0 auto}.singleImgBig-2eea1db9{text-align:center;height:80vh;max-height:600px;overflow:hidden;display:flex;justify-content:center;align-items:center;position:relative}.singleImgBig-2eea1db9 img{width:100%;height:auto;margin:0 0;flex:0 0 100%}@media screen and (max-width: 500px){.singleImg-0c47a15a img{max-height:400px}.singleImgBig-2eea1db9{max-height:400px}}.alignFix-fa27756f svg{margin-top:-2px;color:#FBC02D}\n", ""]);

// Exports
exports.locals = {
	"GalleryBlock": "GalleryBlock-7b2ae44b",
	"singleImg": "singleImg-0c47a15a",
	"singleImgBig": "singleImgBig-2eea1db9",
	"alignFix": "alignFix-fa27756f"
};